import { gql } from '@apollo/client'

export const AEM_STATIC_CONTENT = gql`
  query AemStaticContent($path: String!) {
    aemStaticContent(path: $path)
  }
`
